<template lang="pug">

    div

        .field
            select.ui.selection.dropdown(ref='dropdownEl')
                option
                option(
                    v-for="value in field.values"
                    v-bind:value="value.id"
                ) {{ value.value }}

            error(:$v='$v.value' validator='required')
                | Darf nicht leer sein. Bitte einen Wert auswählen


        dynamic-field(
            v-for='childrenFieldModel in childrenFieldModels'
            v-bind:key='childrenFieldModel.id'
            v-if="isChildVisible(childrenFieldModel)"
            v-bind:field="childrenFieldModel"
            v-bind:field-models="fieldModels"
            v-model="model"
        )


</template>

<script>
    import isEmpty from 'lodash/isEmpty'
    import Error from '@/components/form/FieldError.vue'
    import * as R from 'ramda'

    //noinspection JSUnusedGlobalSymbols
    export default {

        components: {
            dynamicField: () => import('@/components/products/forms/variant-forms/form/DynamicField'),
            Error
        },

        computed: {

            childrenFieldModels() {
                return R.compose(

                    R.filter(field => R.startsWith(`${this.field.id}-`, field.id))

                )(this.fieldModels)
            },

            valueId() {
                const value = this.value[this.field.id]
                return R.compose(

                    R.prop("id"),

                    R.find(R.propEq("value", value))

                )(this.field.values)


            },

            model: {
                get() { return this.value },
                set(value) { this.$emit('input', value) }
            },

            $invalid() {
                return this.$v.$invalid
            }
        },

        data() {
            return {
                selectedValueId: null,
                activeDependency: null
            }
        },

        mounted() {
            this._initDropdown()
        },

        updated() {
            this._initDropdown()
        },

        watch: {
            valueId(newVal) {
                const el = this.$refs.dropdownEl
                if (!el || !$(el).data('module-dropdown')) return
                if (newVal != null) {
                    $(el).dropdown('set selected', String(newVal))
                } else {
                    $(el).dropdown('clear')
                }
            }
        },

        methods: {

            _initDropdown() {
                const el = this.$refs.dropdownEl
                if (!el || $(el).data('module-dropdown')) return
                $(el).dropdown({
                    onChange: (value) => {
                        this.updateValue(value)
                    }
                })
                if (this.valueId != null) {
                    $(el).dropdown('set selected', String(this.valueId))
                }
            },

            $touch() {
                this.$v.$touch()
            },

            isChildVisible(childFieldModel) {
                const selectedValueId = R.defaultTo("", this.selectedValueId)

                if (!R.startsWith(selectedValueId, childFieldModel.id)) {
                    return false
                }

                const valueLevel = selectedValueId.split("-").length
                const childrenLevel = childFieldModel.id.split("-").length

                return childrenLevel === valueLevel + 1
            },

            preparePatch() {
                // Alle Werte von Child-Elemente entfernen
                return R.compose(

                    // Annderung mitteilen
                    // patch => this.$emit('input', patch),

                    // Wieder zu Objekt umwandeln
                    // > [ [ "form-1-1", 1 ] ]
                    // < { form-1-1: 1 }
                    R.fromPairs,

                    // Wert und "Kindswerte entfernen
                    // > [ [ "form-1-1", 1 ], [ "form-1-2", 2 ], [ "form-1-2-1", 3 ] ]
                    // < [ [ "form-1-1", 1 ] ]
                    R.reject(pair => R.startsWith(this.field.id, pair[0])),

                    // Value-Objekt in Tupel umwandeln
                    // > { form-1-1: 1, form-1-2: 2, form-1-2-1: 3 }
                    // < [ [ "form-1-1", 1 ], [ "form-1-2", 2 ], [ "form-1-2-1", 3 ] ]
                    R.toPairs

                )(this.value)
            },

            updateValue(valueId) {
                // Id als gesetzte ID speichern
                this.selectedValueId = valueId
                const patch = this.preparePatch()

                // Wert wurde entfernt
                if (!R.isEmpty(valueId)) {
                    // Wert zu ID ermitterln
                    const selectedValue = R.find(R.propEq("id", valueId), this.field.values)

                    // Wert speichern
                    this.$emit('input', R.assoc(this.field.id, selectedValue.value, patch))
                }
            }
        },

        props: {

            field: {
                type: Object,
                required: true
            },

            fieldModels: {
                type: Array,
                required: true
            },

            value: {
                required: true
            }

        },

        validations: {
            value: {
                required: (value, vm) => {
                    if (vm.field.required === false) {
                        return true
                    }

                    return !isEmpty(value[vm.field.id])
                }
            },
        },

    }

</script>
